import React, { useState } from 'react';
import { SearchIcon, FilterIcon, EditIcon, XIcon, CheckIcon } from 'lucide-react';
interface AppointmentListProps {
  persona: 'patient' | 'receptionist';
}
const mockAppointments = [{
  id: 1,
  date: '2024-01-15',
  time: '10:00 AM',
  doctor: 'Dr. Sarah Johnson',
  patient: 'John Doe',
  type: 'Consultation',
  room: 'Room 101',
  status: 'Confirmed'
}, {
  id: 2,
  date: '2024-01-15',
  time: '2:00 PM',
  doctor: 'Dr. Michael Chen',
  patient: 'Jane Smith',
  type: 'Follow-up',
  room: 'Room 102',
  status: 'Pending'
}, {
  id: 3,
  date: '2024-01-16',
  time: '11:00 AM',
  doctor: 'Dr. Sarah Johnson',
  patient: 'Bob Wilson',
  type: 'Check-up',
  room: 'Room 101',
  status: 'Confirmed'
}, {
  id: 4,
  date: '2024-01-17',
  time: '3:00 PM',
  doctor: 'Dr. Emily Davis',
  patient: 'Alice Brown',
  type: 'Consultation',
  room: 'Room 103',
  status: 'Cancelled'
}];
export function AppointmentList({
  persona
}: AppointmentListProps) {
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [editingId, setEditingId] = useState<number | null>(null);
  const filteredAppointments = mockAppointments.filter(apt => {
    const matchesSearch = persona === 'receptionist' ? apt.patient.toLowerCase().includes(searchTerm.toLowerCase()) || apt.doctor.toLowerCase().includes(searchTerm.toLowerCase()) : apt.doctor.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesFilter = filterStatus === 'all' || apt.status.toLowerCase() === filterStatus.toLowerCase();
    return matchesSearch && matchesFilter;
  });
  return <div className="space-y-6" data-id="element-54">
      {/* Search and Filter */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4" data-id="element-55">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-4 md:space-y-0" data-id="element-56">
          <div className="relative flex-1 max-w-md" data-id="element-57">
            <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-58" />
            <input type="text" placeholder={persona === 'receptionist' ? 'Search by patient or doctor...' : 'Search by doctor...'} value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-59" />
          </div>
          <div className="flex items-center space-x-2" data-id="element-60">
            <FilterIcon className="w-5 h-5 text-gray-400" data-id="element-61" />
            <select value={filterStatus} onChange={e => setFilterStatus(e.target.value)} className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-62">
              <option value="all" data-id="element-63">All Status</option>
              <option value="confirmed" data-id="element-64">Confirmed</option>
              <option value="pending" data-id="element-65">Pending</option>
              <option value="cancelled" data-id="element-66">Cancelled</option>
            </select>
          </div>
        </div>
      </div>
      {/* Appointments List */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-67">
        <div className="overflow-x-auto" data-id="element-68">
          <table className="w-full" data-id="element-69">
            <thead className="bg-gray-50 border-b border-gray-200" data-id="element-70">
              <tr data-id="element-71">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-72">
                  Date & Time
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-73">
                  Doctor
                </th>
                {persona === 'receptionist' && <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-74">
                    Patient
                  </th>}
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-75">
                  Type
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-76">
                  Room
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-77">
                  Status
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-78">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-79">
              {filteredAppointments.map(apt => <tr key={apt.id} className="hover:bg-gray-50" data-id="element-80">
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-81">
                    <div className="text-sm font-medium text-gray-900" data-id="element-82">
                      {apt.date}
                    </div>
                    <div className="text-sm text-gray-500" data-id="element-83">{apt.time}</div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-84">
                    <div className="text-sm text-gray-900" data-id="element-85">{apt.doctor}</div>
                  </td>
                  {persona === 'receptionist' && <td className="px-6 py-4 whitespace-nowrap" data-id="element-86">
                      <div className="text-sm text-gray-900" data-id="element-87">{apt.patient}</div>
                    </td>}
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-88">
                    <div className="text-sm text-gray-900" data-id="element-89">{apt.type}</div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-90">
                    <div className="text-sm text-gray-900" data-id="element-91">{apt.room}</div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-92">
                    <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${apt.status === 'Confirmed' ? 'bg-green-100 text-green-800' : apt.status === 'Pending' ? 'bg-yellow-100 text-yellow-800' : 'bg-red-100 text-red-800'}`} data-id="element-93">
                      {apt.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium" data-id="element-94">
                    <div className="flex space-x-2" data-id="element-95">
                      <button onClick={() => setEditingId(apt.id)} className="text-blue-600 hover:text-blue-900" data-id="element-96">
                        <EditIcon className="w-4 h-4" data-id="element-97" />
                      </button>
                      {apt.status !== 'Cancelled' && <button className="text-red-600 hover:text-red-900" data-id="element-98">
                          <XIcon className="w-4 h-4" data-id="element-99" />
                        </button>}
                      {apt.status === 'Pending' && <button className="text-green-600 hover:text-green-900" data-id="element-100">
                          <CheckIcon className="w-4 h-4" data-id="element-101" />
                        </button>}
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}